var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taginput',{attrs:{"data":_vm.filteredCategories,"autocomplete":"","field":"name","placeholder":"Categories"},on:{"typing":_vm.getFilteredCategories},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4f2db6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CategorySelectDropdown.vue
// module id = null
// module chunks = 